export default {
  fontSize: '14px',
  borderRadius: '1rem',
};
